import { useEffect } from "react";
import { useForm } from "../../useForm";
import { classNames } from "primereact/utils";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";

import SelectMenu from "../../../controls/SelectMenu";
import { userTypeOptions } from "../../../../shared/utility";

const initialFValues = {
  name: "",
  username: "",
  user_type: 0,
  email: "",
  password: "",
};

export default function UserDetailsForm(props) {
  const { actionCall, user, isEdit, resetPassword, setOpen, title } = props;

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false
  );

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("name" in fieldValues) {
      temp.name = null;
      if (fieldValues.name.value === -1) {
        temp.name = "This field is required.";
      }
    }

    if ("username" in fieldValues) {
      temp.username = null;
      if (fieldValues.username.value === -1) {
        temp.username = "This field is required.";
      }
    }

    if ("password" in fieldValues && !isEdit) {
      temp.password = null;
      if (fieldValues.password === "") {
        temp.password = "This field is required.";
      }
    }

    if ("password_confirmation" in fieldValues && !isEdit) {
      temp.password_confirmation = null;
      if (fieldValues.password_confirmation === "") {
        temp.password_confirmation = "This field is required.";
      }

      if (fieldValues.password_confirmation !== values.password) {
        temp.password_confirmation = "The passwords do not match.";
      }
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      actionCall({ ...values, user_type: values.user_type.value });
    }
  };

  useEffect(() => {
    if (isEdit) {
      var userTypeSelected = [];
      if (user) {
        if (user.user_type >= 0) {
          userTypeSelected = userTypeOptions.find(
            (el) => el.value === user.user_type
          );
        }
      }

      setValues({ ...user, user_type: userTypeSelected });
    }
  }, [user, setValues]);

  return (
    <form className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {title}
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6 space-y-4">
          <Input
            label="Name"
            name="name"
            onChange={handleInputChange}
            value={values.name}
            labelOn={true}
            type="text"
            autoComplete="new-password"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />

          <Input
            label="User name"
            name="username"
            onChange={handleInputChange}
            value={values.username}
            labelOn={true}
            type="text"
            autoComplete="new-password"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />

          <Input
            label="Email"
            name="email"
            onChange={handleInputChange}
            value={values.email}
            labelOn={true}
            type="text"
            autoComplete="new-password"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />

          <SelectMenu
            handleInputChange={handleInputChange}
            name="user_type"
            options={userTypeOptions}
            value={values.user_type}
            title={"User Type"}
            error={errors.user_type}
            autoComplete="new-password"
            showLabel={true}
          />

          <>
            <Input
              label="Set Password"
              name="password"
              onChange={handleInputChange}
              value={values.password}
              labelOn={true}
              type="password"
              autoComplete="new-password"
              error={errors.password}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />

            <Input
              label="Confirm Password"
              name="password_confirmation"
              onChange={handleInputChange}
              value={values.password_confirmation}
              labelOn={true}
              type="password"
              autoComplete="new-password"
              error={errors.password_confirmation}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />

            <button
              type="button"
              className={classNames(
                isEdit
                  ? "inline-flex justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  : "hidden"
              )}
              onClick={() => {
                if (values.password === values.password_confirmation) {
                  resetPassword({
                    id: values.id,
                    password: values.password,
                    password_confirmation: values.password_confirmation,
                  });
                } else {
                  setErrors({
                    ...errors,
                    password: "Passwords do not match",
                    password_confirmation: "Passwords do not match",
                  });
                }
              }}
            >
              Reset
            </button>
          </>
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <button
          type="button"
          className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
          onClick={() => setOpen({ childComponent: null, open: false })}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="ml-4 inline-flex justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={handleSubmit}
        >
          {isEdit ? "Save" : "Create"}
        </button>
      </div>
    </form>
  );
}
